import * as React from "react";

import {cs}                           from "@Common/react/chain-services";
import {consumeContext}               from "@Common/react/context";
import {Invoke}                       from "@Common/react/invoke";
import {keyed1}                       from "@Common/react/keyed";
import {UseState}                     from "@Common/react/use-state";
import {isDevQuan}                    from "@Common/ui-components/debug/is-dev-quan";
import {UploadDnmList}                from "@Common/ui-components/heavy/mailing-ui/create-dnm-list-modal/upload-dnm-list/upload-dnm-list";
import {addURLParameterToWindow}      from "@Common/utils/add-url-parameter";
import {removeURLParameterFromWindow} from "@Common/utils/remove-url-parameter";

import {AddAddressPanel} from "./add-address-panel/add-address-panel";
import {SuggestionPanel} from "./suggestion-panel/suggestion-panel";

export const AddAddressModal = ({addAddressContent, officeId, modal, noti}) => cs(
    consumeContext("apis"),
    ({}, next) => Invoke({action: () => addURLParameterToWindow({parameter: "action", value: "add"}), next}),
    ["importContent", ({}, next) => UseState({initValue: "manual", next})],
    ["addPanel", ({importContent}, next) => AddAddressPanel({officeId, importContent, noti, next})],
    ["uploadDnmList", ({importContent}, next) => UploadDnmList({
        onClose: () => modal.close(),
        countryCode: "US",
        onCancel: () => importContent.onChange("manual"),
        officeId,
        next,
    })],
    ["suggestion", (_, next) => UseState({
        initValue: !isDevQuan() ? null : {
            enteredAddress  : {"address":"1115 forest park blvd","address2":"TESET","city":"fort worth","state":"TX","zip":"76110"},
            suggestedAddress: {"address":"1115 forest park blvd","address2":"TESET","city":"fort worth","state":"TX","zip":"76110"},
        },
        next,
    })],
    ({suggestion}, next) => keyed1({key: !!suggestion.value, next}),
    ({addPanel, uploadDnmList, apis, suggestion, importContent}) => importContent.value === "upload" ? (
        uploadDnmList.content
    ) : !suggestion.value ? (
        addPanel.render({
            onCancel: () => {
                removeURLParameterFromWindow({parameter: "action"})
                addAddressContent.onChange(false)
            },
            onSave: async (address) => {
                const response = await apis.next.mailing.dnm.addDoNotMailAddress(address, officeId);
                
                if (response.result === "success") {
                    noti.show({
                        message: "Address Added to Do Not Mail List",
                        color: "green",
                    });
                    addAddressContent.onChange(false);
                } else if (response.suggestedAddress) {
                    suggestion.onChange({
                        enteredAddress  : response.enteredAddress  ,
                        suggestedAddress: response.suggestedAddress,
                    });
                } else if (response ===  "Address Already Exists") {
                    noti.show({
                        message: response,
                        color: "red",
                        duration: 3000,
                    });
                    suggestion.onChange(null);
                } else {
                    throw response;
                }
            },
        })
    ) : (
        SuggestionPanel({
            suggestion: suggestion.value,
            onCancel: () => suggestion.onChange(null),
            onSave: async (address) => {
                const response = await apis.next.mailing.dnm.addDoNotMailAddress(address, officeId, {skipValidation: true});
                if (response.result === "success") {
                    noti.show({
                        message: "Address Added to Do Not Mail List",
                        color: "green",
                        duration: 3000,
                    });
                    addAddressContent.onChange(false);
                } 
                else if (response ===  "Address Already Exists") {
                    noti.show({
                        message: response,
                        color: "red",
                        duration: 3000,
                    });
                    suggestion.onChange(null);
                }
                else {
                    throw response;
                }
            },
        })
    ),
);

